export const TAG = {
  KIND: {
    SUCCESS: "success",
    DANGER: "danger",
    WARNING: "warning",
    PRIMARY: "primary",
    MUTED: "muted",
    WHITE: "white",
    PINK: "pink",
    PURPLE: "purple",
  },
  SIZE: {
    MEDIUM: "medium",
    SMALL: "small",
  },
};